import { languages } from "../../../dummyData/dummyData";
import NavBar from "../../organisms/NavBar/NavBar";
import Footer from "../../organisms/Footer/Footer";
import MainTemplate from "../generic/MainTemplate/MainTemplate";
import JobPositionsList from "../../organisms/JobPositionsList/JobPositionsList";
import { useDocumentTitle } from "../../../hooks/useDocumentTitle";
import TopBanner from "../../molecules/TopBanner/TopBanner";
import { useContext } from "react";
import { UserContext } from "../../../contexts/UserContext";
import { SCOPE_COMPETENCE_FRAMEWORK_EDIT } from "../../../constants/scopes";

const JobPositionsTemplate = ({ data }) => {
  const { userContextLevel, userData } = useContext(UserContext);

  const pageHeader = languages.EN.labels.jobPositions;

  useDocumentTitle(pageHeader);

  return (
    <section>
      <NavBar />
      <TopBanner
        header={pageHeader}
        path={[
          {
            name: pageHeader,
            link: "#",
          },
        ]}
      />
      <MainTemplate>
        <JobPositionsList data={data} withManagement={[2, 3].includes(userContextLevel) && userData.scopes.includes(SCOPE_COMPETENCE_FRAMEWORK_EDIT)} />
      </MainTemplate>
      <Footer data={languages.EN.footer} />
    </section>
  );
};

export default JobPositionsTemplate;
